"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionActions = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
/**
 * Expansion panel component.
 * @param {Object} props - React props
 */
var AccordionActions = function AccordionActions(_ref) {
  var className = _ref.className,
    children = _ref.children,
    dataTestId = _ref['data-testid'];
  var customClass = 'expansion-panel-actions';
  if (className) customClass += " ".concat(className);
  return /*#__PURE__*/_react["default"].createElement(_styles.Styled, {
    className: customClass,
    "data-testid": dataTestId
  }, children);
};
exports.AccordionActions = AccordionActions;